import * as React from 'react';
import InputComponent from './InputComponent';

interface IPostcodeState {
    hasError: boolean
    postcodeValue: string
}

interface IPostcodeProps {
    content: any
    validateInput(inputID: string, isCorrect: boolean): any
    onValueChange(input: string): void
}


class PostcodeInput extends React.Component<IPostcodeProps, IPostcodeState> {

    constructor(props: IPostcodeProps) {
        super(props);
        this.state = {
            hasError: false,
            postcodeValue: '',
        }

        this.handleError = this.handleError.bind(this)
        this.changeInputValue = this.changeInputValue.bind(this)
        this.validatePostcodeInput = this.validatePostcodeInput.bind(this)
        this.preventSpecificKeys = this.preventSpecificKeys.bind(this)
    }

    public changeInputValue(input: string): void {
        if (input.length > 4) {
            input = input.slice(0, 4)
        }
        this.setState({
            postcodeValue: input
        }, () => {
            if (this.state.hasError) {
                this.handleError()
            } else {
                this.validatePostcodeInput()
            }
            this.props.onValueChange(input);
        })
    }
    public handleError(): void {
        if (this.state.postcodeValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validatePostcodeInput()
            })
        } else if (!this.state.postcodeValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validatePostcodeInput()
            })
        } else {
            this.setState({
                hasError: true
            })
        }
    }

    public validatePostcodeInput(): void {
        if (!this.state.hasError && this.state.postcodeValue.length === 4) {
            this.props.validateInput('additional', true)
        } else {
            this.props.validateInput('additional', false)
        }
    }

    public preventSpecificKeys(e: React.KeyboardEvent): any {
        if (e.key === '-' || e.key === '.' || e.key === 'e') {
            e.preventDefault()
            return false
        }
        return true
    }


    public render() {
        if (this.props.content === null) {
            return null
        }

        return (
            <InputComponent
                type="number"
                inputValue={this.state.postcodeValue}
                hasError={this.state.hasError}
                placeholder={this.props.content.postcodeInputLabel}
                errorMessage={this.props.content.postcodeInputError}
                maxLength={4}
                changeInputValue={this.changeInputValue}
                checkInput={this.handleError}
                preventSpecificKeys={this.preventSpecificKeys} />
        )
    }
}

export default PostcodeInput





// WEBPACK FOOTER //
// ./src/components/Inputs/PostcodeInput.tsx